export function statusFilterRequest<T extends { statuses?: string[] }>(filters?: T) {
  const { statuses, ...rest } = filters ?? ({} as T)
  return {
    params: statuses?.length ? { ...rest, status: statuses } : rest,
  }
}
